import React from 'react';
import SidePanelLayout from "layouts/SidePanelLayout";
import {SwiftTransactionContextProvider} from "./context";
import SwiftTransactionFilter from "./SwiftTransactionFilter";
import SwiftTransactionPanel from "./SwiftTransactionPanel";

export default function SwiftTransaction() {

    return(<>
        <SwiftTransactionContextProvider>
            <SidePanelLayout
                sideComponent={SwiftTransactionFilter}
                mainComponent={SwiftTransactionPanel}>
            </SidePanelLayout>
        </SwiftTransactionContextProvider>
    </>);

}